<template>
  <BaseSidebarDrawer v-model="localModelValue" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="localModelValue = false" />
        <span class="font-bold text-sm">دسترسی به صورتحساب</span>
      </div>
      <div class="overflow-y-auto no-scrollbar overscroll-none">
        <template v-if="!smAndDown">
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">1</div>
              <span class="text-xs leading-5">گزینه «صورتحساب» را از نوار کناری انتخاب کنید تا صورتحساب‌های خود را مشاهده یا دانلود نمایید.</span>
            </div>
            <img src="~@/assets/images/support/access-to-invoice-1.webp" class="w-full h-[206px] object-contain mt-4" />
          </div>
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">2</div>
              <span class="text-xs leading-5">
                همچنین می‌توانید با استفاده از فیلترها، نتایج جستجو را مطابق با نیاز خود محدود و دقیق‌تر کنید. مواردی مانند تاریخ، نوع سند، نوع
                تراکنش، تاریخ بارگیری، شماره بارنامه و شماره سفارش قابل فیلتر کردن هستند.
              </span>
            </div>
            <img src="~@/assets/images/support/access-to-invoice-2.webp" class="w-full h-[206px] object-contain mt-4" />
            <img src="~@/assets/images/support/access-to-invoice-3.webp" class="w-full h-[206px] object-contain mt-3" />
          </div>
        </template>
        <template v-else>
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex items-center gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">1</div>
              <span class="text-xs">ابتدا از نوار پایین، گزینه بیشتر را انتخاب کنید.</span>
            </div>
            <img src="~@/assets/images/support/mobile-more-menu.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
          </div>
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex items-center gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">2</div>
              <span class="text-xs">گزینه صورتحساب را انتخاب کنید</span>
            </div>
            <img src="~@/assets/images/support/mobile-access-to-invoice-1.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
          </div>
          <div class="pt-6 pb-8 px-5 md:px-6">
            <div class="flex gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 flex-shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">3</div>
              <span class="text-xs leading-5">
                در قسمت صورتحساب می توانید با استفاده از فیلترها، نتایج جستجو را مطابق با نیاز خود محدود و دقیق‌تر کنید.
              </span>
            </div>
            <img src="~@/assets/images/support/mobile-access-to-invoice-2.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
            <img src="~@/assets/images/support/mobile-access-to-invoice-3.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
          </div>
        </template>
      </div>
    </div>
  </BaseSidebarDrawer>
</template>

<script setup lang="ts">
import BaseSidebarDrawer from "@/components/base/BaseSidebarDrawer.vue";
import { computed } from "vue";
import { useDisplay } from "vuetify";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const { smAndDown } = useDisplay();

const emit = defineEmits(["update:modelValue"]);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<style scoped></style>
